import { useDispatch } from "react-redux";
import { fetchOfficeByCampusId, getTicket } from "../../pages/actions/actions";
import { errorFormate } from "../../utils/helper";
import { ShowAlert } from "../../utils/showAlert";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useNavigate } from "react-router-dom";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";


export const useGetTicketData=({id}:any)=>{
 
    const { getTicketData: isTicketDataPresent } = UseGetStoreData();
    const {getTicketData}=UseGetStoreData()
    const dispatch = useDispatch();
    const navigate = useNavigate();
   
    
  
useEffect(() => {
  if (getTicketData?.campusId) {
    fetchOfficeByCampusId({ campusId: getTicketData.campusId, dispatch });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [getTicketData?.campusId]);


    const getTicketTicketId = async (ticketId: string) => {
        
        try {
          return await getTicket({ ticketId, navigate, dispatch });
        } catch (e) {
          ShowAlert("warning", errorFormate({ e, service: "getTicket" }));
        }
      };
      const shouldFetch = id
        ? !isTicketDataPresent || isTicketDataPresent._id !== +id
        : navigate("/");
      const { data, isLoading, isError } = useQuery({
        queryKey: ["ticket", id],
        queryFn: shouldFetch ? () => getTicketTicketId(id || "1") : skipToken,
      });

      return{shouldFetch,data,isLoading,isError}
}